/* Measures the announcement bar's ACTUAL rendered height on mobile
   and stores it as a CSS variable, so the header's compensating
   margin-top (see header-mobile-spacing-fix.css) always matches
   reality instead of relying on a hardcoded guess that drifts out
   of sync whenever the bar's content changes. */
(function () {
  function syncAnnouncementHeight() {
    var bar = document.querySelector('.announcement-topbar');
    if (!bar) return;
    var height = bar.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--dynamic-announcement-height', height + 'px');
    }
  }
  syncAnnouncementHeight();
  document.addEventListener('DOMContentLoaded', syncAnnouncementHeight);
  window.addEventListener('load', syncAnnouncementHeight);
  window.addEventListener('resize', syncAnnouncementHeight);
})();
